(function() {
  
  angular
    .module('meanApp')
    .controller('TagsController', tagsController);

    tagsController.$inject = ['$scope'];

  	function tagsController($scope) {

	    this.means = [{
	    	position : 0,
	    	name : 'complicated'
	    },{
	    	position: 0,
	    	name: 'nohob'
	    },
	    {
	    	position : 3,
	    	name : 'eco'
	    },{
	    	position : 11,
	    	name : 'nooven'
	    },{
	    	position : 13,
	    	name : 'nomicrowave'
	    },{
	    	position : 21,
	    	name : 'fast'
	    }];

		this.wayoflife = [{
	    	position : 1,
	    	name : 'protein'
	    }, {
	    	position : 4,
	    	name : 'lowcarb'
	    },{
	    	position : 5,
	    	name : 'nopig'
	    },{
	    	position : 6,
	    	name : 'vegan'
	    },{
	    	position : 7,
	    	name : 'paleo'
	    },{
	    	position : 8,
	    	name : 'vegetarian'
	    },{
	    	position : 10,
	    	name : 'nogluten'
	    },{
	    	position: 9,
	    	name: 'local'
	    },{
	    	position : 18,
	    	name : 'lowcalory'
	    }, {
	    	position : 19, 
	    	name: 'season'
	    }];

	    this.desire = [{
	    	position : 2,
	    	name : 'cold'
	    },{
	    	position : 12,
	    	name : 'maincourse'
	    },{
	    	position : 14,
	    	name : 'entry'
	    },{
	    	position : 15,
	    	name : 'pleasure'
	    },{
	    	position : 16,
	    	name : 'savory'
	    },{
	    	position : 17,
	    	name : 'aperitif'
	    },{
	    	position : 20,
	    	name : 'dessert'
	    },{
	    	position : 22,
	    	name : 'sweet'
	    },{
	    	position : 23,
	    	name : 'hot'
	    }];

	    this.returnTagList = function () {
	    	var toBeReturned = [];

	    	if (this.meanActivated){
	    		toBeReturned = toBeReturned.concat(this.means);
	    	}

	    	if (this.desireActivated) {
	    		toBeReturned = toBeReturned.concat(this.desire);
	    	}

	    	if (this.wayoflifeactivated) {
	    		toBeReturned = toBeReturned.concat(this.wayoflife);
	    	}

	    	//now sort the positions
	    	toBeReturned.sort(function(a, b) {
	    		if (a.position > b.position) {
	    			return -1;
	    		}
	    		else {
	    			return 1;
	    		}
	    	});

	    	this.tagList = toBeReturned;

	    };
	    
	    this.all = true;
	    this.meanActivated = true;
	    this.desireActivated = true;
	    this.wayoflifeactivated = true;

	    this.returnTagList();

	    //TODO creer des onclick
	    this.onMeanClicked = function () {
	    	this.meanActivated = true;
    		this.desireActivated = false;
    		this.wayoflifeactivated = false;
	    	this.returnTagList();
	    };

	    this.ondesireClicked = function () {
	    	this.meanActivated = false;
    		this.desireActivated = true;
    		this.wayoflifeactivated = false;
	    	this.returnTagList();
	    };

	    this.onwayoflifeClicked = function () {
	    	this.meanActivated = false;
    		this.desireActivated = false;
    		this.wayoflifeactivated = true;
	    	this.returnTagList();
	    };

	    this.allClicked = function () {
	    	this.meanActivated = true;
    		this.desireActivated = true;
    		this.wayoflifeactivated = true;
	    	this.returnTagList();
	    };

	    this.data = {
		    availableOptions: [
		      {name : 'Tous les Tags', id: '1'},
		      {name : 'Tags de Mode de vie', id: '2'},
		      {name : "Tags d'Envies", id: '3'},
		      {name : "Tags d'Exigences", id: '4'}
		    ],
		    selectedOption:  {name : 'Tous les Tags', id: '1'}
		};

	    this.selectChanged = function() {

			switch(this.data.selectedOption.id) {
			    case '1':
			        this.allClicked();
			        break;
			    case '2':
			        this.onwayoflifeClicked();
			        break;
			    case '3':
			        this.ondesireClicked();
			        break;
			    case '4':
			        this.onMeanClicked();
			        break;
			}
		};

	    //function to increase the  index
	}

})();